import React from "react";
import { Link } from "react-router-dom";
import Grain, { GrainFilters } from "../Grain/Grain";
import Nav from "../Nav/Nav";
import Footer from "../Footer/Footer";
import "./styles.css";

const LegalDocument = ({ title, updatedAt, children }) => {
  return (
    <>
      <GrainFilters />
      <Nav />

      <main>
        <header className="legal-hero dark">
          <div className="glow glow-a" />
          <div className="glow glow-b" />
          <div className="gridlines" />
          <div className="sq" style={{ width: 90, height: 90, top: "30%", right: "10%" }} />
          <div className="sq" style={{ width: 54, height: 54, bottom: "14%", right: "28%", animationDelay: "2s" }} />
          <Grain variant="hard" />
          <Grain variant="soft" />

          <div className="container">
            <Link to="/" className="legal-back-link">
              ← Voltar para o início
            </Link>
            <div className="pill">
              <span className="dot" />
              Documento legal
            </div>
            <h1 className="display">{title}</h1>
            {updatedAt && <p className="legal-updated">Última atualização: {updatedAt}</p>}
          </div>
        </header>

        <section className="legal-body dossie">
          <div className="margin-line" />
          <Grain variant="paper" />
          <div className="container">
            <article className="legal-card">
              <span className="legal-tab">Documento</span>
              {children}
            </article>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default LegalDocument;
